import "./App.css";
import Routes from "./routes/routes";
import "react-toastify/dist/ReactToastify.css";
import "tinymce/skins/ui/oxide/skin.min.css";
import "tinymce/skins/ui/oxide/content.min.css";
import "tinymce/skins/ui/oxide/skin.min.css";

function App() {
  return <Routes />;
}

export default App;
